/**
 * updateMessage will take the current messages, and the new message,
 * and update an existing message if the current one already exists.
 * Otherwise append it to the array.
 * @param {object} data - Object containing current and new messages.
 * @returns {array} - New message array.
 */
export default function updateMessage(data) {
  const { message, newMessages } = data

  const messages = [ ...newMessages ]

  let existingMessage
  messages.forEach(m => {
    if (deepEqual(m, message)) {
      existingMessage = m
    }
  })

  if (!existingMessage) {
    messages.push(message)
  } else {
    existingMessage.data = message.data
  }

  return messages
}

const deepEqual = (v1, v2) => {
  if (typeof v1 === 'function' && typeof v2 === 'function') return v1.toString() === v2.toString()
  if (v1 instanceof Object && v2 instanceof Object) {
    if(Object.keys(v1).length !== Object.keys(v2).length) return false
    for(let key in v1) {
      if(!(key in v2)) return false
      if(!deepEqual(v1[key], v2[key])) return false
    }
    return true
  }
  return v1 === v2
}
